<template>
  <div class="mt-5 container">
    <div class="one-only-cost">
      <div class="estimated-cost d-flex justify-content-between">
        <div class="small-gray-text">Szacowany koszt</div>
        <div class="big-cost" v-if="!hasPrices">dane częściowe</div>
        <div class="big-cost" v-else-if="containParts">
          {{ thousands(estimatedMin) }} - {{ thousands(estimatedMax) }} pln
        </div>
        <div class="big-cost" v-else>
          {{ thousands(workMin) }} - {{ thousands(workMax) }} pln
        </div>
      </div>
      <cost-proportions :proportions="proportions" :hasPrices="hasPrices" />
      <div class="d-flex justify-content-between">
        <p class="bold">Robocizna</p>
        <p class="cost">
          {{ thousands(workMin) }} - {{ thousands(workMax) }} pln
        </p>
      </div>
      <div class="d-flex justify-content-between">
        <p class="bold">Części</p>
        <p class="cost" v-if="!hasPrices">brak danych</p>
        <p class="cost" v-else-if="containParts">
          {{ thousands(partMin) }} - {{ thousands(partMax) }} pln
        </p>
        <p class="cost" v-else>niewymagane</p>
      </div>

      <div class="justify-content-between">
        <div v-for="part in this.usedParts" :key="part.name">
          <div>
            <p class="small-text">
              <b>{{ part.name }}</b>
            </p>
          </div>
          <div
            v-if="
              elitePrices[part.partNo] &&
              elitePrices[part.partNo].prices.length !== 0
            "
          >
            <div
              v-for="price in this.elitePrices[part.partNo].prices"
              :key="price.name"
              class="d-flex justify-content-between"
            >
              <a
                v-if="part.partNo"
                class="elite-text"
                :href="price.link"
                @click="handlePartPriceClick"
              >
                {{ price.name }}
              </a>
              <p class="elem-cost" v-if="price.price">
                {{ thousands(price.price) }} pln
              </p>
            </div>
          </div>
          <div>
            <div class="elite">
              <a
                v-if="part.partNo"
                class="elite-text"
                :href="
                  'https://sklep.elitpolska.pl/pl/katalog/?query=' + part.partNo
                "
                @click="handleAllPartPricesClick"
              >
                zobacz ceny tej części >>
              </a>
              <span v-else>&nbsp;</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CostProportions from "@/components/repair-detail-components/CostProportions";
import axios from "axios";
import { sendGTMEvent } from "@/utils";
export default {
  mounted() {
    this.fetchPrices();
  },
  components: { CostProportions },
  props: {
    workMin: Number,
    workMax: Number,
    partMin: Number,
    partMax: Number,
    estimatedMax: Number,
    estimatedMin: Number,
    containParts: Boolean,
    hasPrices: Boolean,
    usedParts: Array,
  },
  data() {
    return {
      elitePrices: {},
    };
  },
  methods: {
    thousands(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    fetchPrice(oe) {
      console.log("fetchPrice", oe);
      axios.get(`/api/scrapperv2/prices/${oe}`).then((response) => {
        if (response.status === 200) {
          this.elitePrices[oe] = response.data;
        } else {
          this.elitePrices[oe] = null;
        }
        console.log("axios", this.elitePrices);
      });
    },
    fetchPrices() {
      if (this.usedParts instanceof Array) {
        this.usedParts.forEach((elem) => this.fetchPrice(elem.partNo));
      }
    },
    handlePartPriceClick(event) {
      event.preventDefault();
      sendGTMEvent({ event: "kliknięcie-link-produktowy" }, () => {
        window.location.href = event.target.href;
      });
    },
    handleAllPartPricesClick(event) {
      event.preventDefault();
      sendGTMEvent(
        {
          event: "kliknięcie-link-zbiorczy",
        },
        () => {
          window.location.href = event.target.href;
        }
      );
    },
  },
  computed: {
    proportions() {
      if (this.partMax && this.partMin) {
        const averagePart = (this.partMax + this.partMin) / 2;
        const averageWork = (this.workMax + this.workMin) / 2;
        const averageTotal = averagePart + averageWork;
        return Math.floor((averageWork / averageTotal) * 100);
      } else {
        return 100;
      }
    },
  },
};
</script>
<style scoped>
.one-only-cost {
  border-bottom: 1px solid rgba(218, 218, 218, 1);
  margin-bottom: 76px;
}

.elite {
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
  margin-right: 0;
  padding-bottom: 10px;
}

.elite-text {
  font-size: 13px;
  color: #797979;
}

.estimated-cost {
  border-bottom: 1px solid black;
}

.estimated-cost .small-gray-text {
  color: #797979;
  font-size: 13px;
  margin-bottom: 5px;
  margin-top: auto;
  line-height: 18px;
  font-weight: 400;
}

.small-text {
  font-size: 13px;
  margin-bottom: 10px;
  margin-top: auto;
  line-height: 18px;
  font-weight: 400;
}

.estimated-cost .big-cost {
  font-family: "Comfortaa", serif;
  color: var(--brand-pink);
  font-size: 24px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: -0.015em;
}

.bold {
  font-weight: bold;
  font-size: 16px;
}
.cost {
  color: var(--brand-pink);
  font-family: "Comfortaa", serif;
  font-size: 20px;
}
.elem-cost {
  color: var(--brand-pink);
  font-family: "Comfortaa", serif;
  font-size: 13px;
}
</style>
